/*
* ToggleSoundButton.js
* Created on 10-12-2019
* @author Swen Meeuwes for &ranj
*/

import SoundEvent from "../event/SoundEvent";

export default class ToggleSoundButton {
    constructor(dispatcher, soundManager) {
        this._dispatcher = dispatcher;
        this._soundManager = soundManager;

        this._dom;
    }

    initialize() {
        this._dom = document.getElementById("toggleSoundButton");
        this._dom.addEventListener("click", this._handleClick.bind(this));

        this._dom.style.display = "block";
    }

    // Used to update mute state when the player mutes before the video player and sound manager are loaded
    forceUpdate() {
        this._setMuted(this._muted);
    }

    _handleClick(evt) {
        this._toggle();
    }

    _toggle() {
        this._muted = !this._soundManager.getMute();
        this._setMuted(this._muted);
    }

    _setMuted(muted) {
        var soundEvent;
        if (muted) {
            soundEvent = new SoundEvent(SoundEvent.MUTE);
            this._dispatcher.dispatch(soundEvent.type, { data: soundEvent });
        } else {
            soundEvent = new SoundEvent(SoundEvent.UNMUTE);
            this._dispatcher.dispatch(soundEvent.type, { data: soundEvent });
        }

        this._dom.src = muted ? ToggleSoundButton.IMAGES.off : ToggleSoundButton.IMAGES.on;
    }
}

ToggleSoundButton.IMAGES = {
    "on": "assets/images/SoundOn.png",
    "off": "assets/images/SoundOff.png",
}